import { render, staticRenderFns } from "./ForbiddenKeywordsModule.vue?vue&type=template&id=2a8d9de6"
import script from "./ForbiddenKeywordsModule.vue?vue&type=script&lang=js"
export * from "./ForbiddenKeywordsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports